// DeleteQuestionDialog.jsx - Soru silme onay dialog'u
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';
import { deleteQuestion } from '../../redux/testSlice';

const DeleteQuestionDialog = ({ open, onClose, question, testId, loading }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    if (question) {
      dispatch(deleteQuestion({
        testId: testId,
        questionId: question._id
      }));
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Question</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete this question? This action cannot be undone.
        </Typography>
        {question && (
          <Typography variant="body2" color="text.secondary" mt={2}>
            <strong>Question to be deleted:</strong> {question.questionText}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={handleDelete} 
          color="error" 
          variant="contained"
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteQuestionDialog;